import { CtBatch } from '@ps-gui/claims-terminal-shared';

export const countForderungsaufstellungen = (ctBatch: CtBatch) =>
  ctBatch.documents.filter((document) =>
    document.documentClasses.includes('25_Q3_FORDERUNGSAUFSTELLUNG'),
  ).length;
